(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-event', {
            parent: 'entity',
            url: '/document-event',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-event/document-events.html',
                    controller: 'DocumentEventController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentEvent');
                    $translatePartialLoader.addPart('eventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-event-detail', {
            parent: 'entity',
            url: '/document-event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-event/document-event-detail.html',
                    controller: 'DocumentEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentEvent');
                    $translatePartialLoader.addPart('eventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentEvent', function($stateParams, DocumentEvent) {
                    return DocumentEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-event-detail.edit', {
            parent: 'document-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-event.new', {
            parent: 'document-event',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                eventTimestamp: null,
                                eventGroup: null,
                                description: null,
                                restricted: false,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('document-event');
                });
            }]
        })
        .state('document-event.edit', {
            parent: 'document-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-dialog.html',
                    controller: 'DocumentEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-event.delete', {
            parent: 'document-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-event/document-event-delete-dialog.html',
                    controller: 'DocumentEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentEvent', function(DocumentEvent) {
                            return DocumentEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-event', null, { reload: 'document-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
